import appQueryClient from '../appQueryClient';
import { permissions } from '../constants';
import { checkPermission } from '../helpers/checkPermission';

export const authErrorCode = 'AUTHORIZATION_REQUIRED';

export const getUserSlug = () => 'employee';
export const getUserId = () => localStorage.getItem('userId');
export const getUserToken = () => localStorage.getItem('userToken');
export const getLogoutUrl = () => localStorage.getItem('logoutUrl');

export const setUserSlug = () => { };
export const setUserId = (userId) => localStorage.setItem('userId', userId);
export const setUserToken = (userToken) => localStorage.setItem('userToken', userToken);
export const setLogoutUrl = (logoutUrl) => localStorage.setItem('logoutUrl', logoutUrl);

export const removeLogoutUrl = () => localStorage.removeItem('logoutUrl');
export const removeUserId = () => localStorage.removeItem('userId');
export const removeUserToken = () => localStorage.removeItem('userToken');

export const removeCreds = (nullifyCurrentUser = true) => {
  removeUserId();
  removeUserToken();
  if (nullifyCurrentUser) appQueryClient.setQueryData('currentUser', null);
  const logoutUrl = getLogoutUrl();
  removeLogoutUrl();
  if (logoutUrl) window.location.href = logoutUrl;
};

export const logOutMeta = {
  url: () => `/${getUserSlug()}/logout`,
  data: () => ({ redirectUrl: window.location.origin }),
};

export const isAcceptedUser = (user) => checkPermission(user.roles, [permissions.ANALYTICS_DASHBOARD_USER, permissions.CAPITAL_USER]);

export const isLogOutStatus = (statusCode) => (statusCode === 401 || statusCode === 403);
